import { Box } from '@chakra-ui/react';
import { ArticleTargetTiers } from './targetTiers/ArticleTargetTiers';
import { ManagementCard } from './ManagementCard';
import { useTranslation } from 'react-i18next';

export function TargetTiersManagement({ articleId }: { articleId: number }) {
  const { t } = useTranslation();
  return (
    <ManagementCard
      title={t('article.management.targetTiers')}
      description={t('article.management.targetTiersDescription')}
    >
      <Box minH="180px">
        <ArticleTargetTiers articleId={articleId} />
      </Box>
    </ManagementCard>
  );
}
